import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const ChartSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				d="M17 20V8.5M12 20V5.5M7 20V12"
				stroke="currentColor"
				strokeWidth="2.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SystemIconTemplate>
	)
})
